const { log_debug, log_info, log_error } = require("../utils/log");

const TIMEOUT = 10000;

export const doGetRequest = async (url) => {
  log_debug(url);
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
    timeout: TIMEOUT,
  });
  const resJson = await response.json();
  log_debug(JSON.stringify(resJson));
  return resJson;
};

export const doPostRequest = async (url, data) => {
  console.log(url);
  console.log(JSON.stringify(data));
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
    timeout: TIMEOUT,
  });
  const resJson = await response.json();
  log_debug(JSON.stringify(resJson));
  return resJson;
};
export const doGetRequestExcel = async (
  url,
  tournamentname,
  districtname,
  teamname
) => {
  log_debug(url);

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
    timeout: TIMEOUT,
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // Read response as a binary buffer
  const buffer = await response.arrayBuffer();

  // Convert the buffer into a Blob for downloading
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  // Extract filename from Content-Disposition header
  const contentDisposition = response.headers.get("Content-Disposition");
  let filename = "download.xlsx"; // Default filename
  if (contentDisposition && contentDisposition.includes("filename=")) {
    filename = contentDisposition
      .split("filename=")[1]
      .split(";")[0]
      .replace(/"/g, "");
  }
  if (teamname) {
    filename = teamname + ".xlsx";
  } else if (tournamentname) {
    filename = tournamentname + ".xlsx";
  } else if (districtname) {
    filename = districtname + ".xlsx";
  }

  console.log("contentDisposition", contentDisposition);

  // Create a temporary link element to trigger download
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = filename; // Set the filename
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  log_debug("Excel file downloaded successfully.");
};



export const doDeleteRequest = async (url) => {
  log_debug(url);
  const response = await fetch(url, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
    timeout: TIMEOUT,
  });
  const resJson = await response.json();
  log_debug(JSON.stringify(resJson));
  return resJson;
};

export const doPutRequest = async (url, data) => {
  log_debug(url);
  const response = await fetch(url, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
    timeout: TIMEOUT,
  });
  const resJson = await response.json();
  log_debug(JSON.stringify(resJson));
  return resJson;
};


export const doPostRequestImageFile = async (url, formData) => {
  log_debug(url);
  log_debug(JSON.stringify(formData));
  const response = await fetch(url, {
    method: "POST",
    body: formData,
    // headers: {
    //   "Content-Type": "multipart/form-data",
    // },
  });
  log_debug(JSON.stringify(response));
  return response;
};
